import { render, staticRenderFns } from "./VisionGroups.vue?vue&type=template&id=e6b15f78&scoped=true"
import script from "./VisionGroups.vue?vue&type=script&lang=js"
export * from "./VisionGroups.vue?vue&type=script&lang=js"
import style0 from "./VisionGroups.vue?vue&type=style&index=0&id=e6b15f78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b15f78",
  null
  
)

export default component.exports